{
  "hero": {
    "verified": "Verified by DEC",
    "kicker": "Profilo pubblico",
    "share": "Condividi questa pagina"
  },
  "impact": {
    "eyebrow": "Impatto generato",
    "title": "Anni di scelte pulite, raccontate in numeri.",
    "lede": "Ogni kWh prodotto dagli impianti DEC sostituisce energia da fonti fossili sulla rete italiana. Questo è ciò che è stato evitato dall'inizio del progetto, verificato in tempo reale dalla piattaforma DEC.",
    "metricLabel": "tCO₂ evitate · totale",
    "note": "Calcolato sul fattore di emissione della rete IT (Terna 2025).",
    "flights": {
      "label": "Voli evitati",
      "desc": "Tratta Londra-New York, andata e ritorno, in classe economy."
    },
    "trees": {
      "label": "Alberi annuali",
      "desc": "Numero di alberi maturi necessari per assorbire la stessa CO₂ in un anno."
    },
    "households": {
      "label": "Famiglie",
      "desc": "Consumo elettrico annuale di un nucleo familiare italiano medio."
    }
  },
  "narrative": {
    "eyebrow": "Perché lo facciamo"
  },
  "plants": {
    "tag": "Gli impianti",
    "title": "<h2>Ogni impianto è un passo concreto verso un futuro rinnovabile</h2>",
    "description": "Supportiamo in maniera concreta i produttori di energia rinnovabile, permettendo loro di costruire sempre più impianti. Di seguito una panoramica degli impianti che abbiamo contrattualizzato.",
    "producing": "In produzione",
    "panels": "Pannelli",
    "since": "In esercizio"
  },
  "production": {
    "tag": "Produzione",
    "title": "<h2>Il nostro impegno, in totale trasparenza</h2>",
    "description": "Monitora in diretta la quantità di energia che viene prodotta dai nostri impianti.",
    "chartTitle": "Energia prodotta · MWh per mese",
    "chartSub": "Aggregato di tutti gli impianti · dati verificati DEC",
    "peakBadge": "Picco",
    "peak": "Picco di produzione:",
    "ytd": "YTD totale ·",
    "produced": "Prodotto",
    "expected": "Previsto"
  },
  "map": {
    "eyebrow": "Geografia",
    "title": "Da dove arriva l'energia.",
    "lede": "La posizione approssimativa degli impianti collegati al profilo.",
    "activePlants_one": "{{count}} impianto attivo",
    "activePlants_other": "{{count}} impianti attivi",
    "totalSuffix": "totali",
    "legend_one": "Impianto attivo · {{count}}",
    "legend_other": "Impianti attivi · {{count}}"
  },
  "embed": {
    "eyebrow": "Embed widget",
    "title": "Mostra il tuo impatto sul tuo sito.",
    "lede": "Un widget compatto con kWh prodotti e tCO₂ evitate aggiornati ogni 24 ore. Copia il codice qui sotto e incollalo dove vuoi sul tuo sito.",
    "copy": "Copia",
    "copied": "Copiato",
    "metric1": "kWh prodotti",
    "metric2": "CO₂ evitate · cumulativo",
    "syncedAt": "Aggiornato",
    "poweredBy": "Powered by"
  },
  "cta": {
    "text": "Vuoi alimentare la tua azienda con il solare?",
    "link": "Scopri DEC"
  },
  "bookCta": {
    "tag": "Scopri tutti i vantaggi",
    "title": "<h2>Vuoi un profilo come questo per la tua azienda?</h2>",
    "description": "Prenota una consulenza gratuita con i nostri esperti per ricevere un'analisi su misura su quanto puoi risparmiare con DEC (sui tuoi consumi elettrici).",
    "button": "Prenota un incontro",
    "contact": "Oppure scrivi a"
  },
  "share": {
    "message": "Da' un'occhiata!",
    "copyLink": "Copia link"
  },
  "mapPopup": {
    "powerRented": "Potenza affittata:",
    "panelsRented": "Pannelli affittati:",
    "unknownPower": "Potenza sconosciuta"
  }
}
